import { Component, OnInit } from '@angular/core';
import { LdsUserService } from '../../services/lds-user.service';
import { ActivatedRoute, Router   } from '@angular/router';
import { map } from 'rxjs/operators';
import { DataAnalyticsService } from '../../data-analytics/data-analytics.service';
import { IconsService } from '../../services/icons.service';
import { LwProductService } from '../../lw-product/lw-product.service';
import { DateTime } from 'luxon';
import { LdsEventBusService } from '../../services/lds-event-bus.service';
import { DemoAccountService } from '../../demo-account.service';
import { PopupComponent } from '../../common-components/popup/popup.component';
import { DataExportService } from '../../services/data-export.service';
import { MatDialog } from '@angular/material/dialog';
import { TimeSelectComponent } from '../../time-select/time-select.component';

@Component({
    selector: 'lds-switch-detail',
    templateUrl: './switch-detail.component.html',
    styleUrls: ['./switch-detail.component.css'],
    standalone: false
})
export class SwitchDetailComponent implements OnInit {
  public featureSet;
  public features;
  public icon_margin;
  public totalOnData;
  public deviceType;
  public switchData;
  public showLinkBtns;
  public status;
  public timespan: string;
  public startTime;
  public endTime;
  public room;
  private featuresToShow = ['dimLevel', 'switch', 'movement', 'energy', 'power',
    'temperature', 'targetTemperature'/*, 'batteryLevel'*/, 'buttonPress', 'windowPosition', 'valveLevel'];
  constructor(private route: ActivatedRoute, private rout: Router, public icons: IconsService,
    public user: LdsUserService, private dialog: MatDialog, private dataAnalytics: DataAnalyticsService, private productService: LwProductService, private eventBus: LdsEventBusService, private demo: DemoAccountService, private popup: PopupComponent, private dataExport: DataExportService) { }

  ngOnInit() {
    this.timespan = 'weekly';
    this.route.params.pipe(map(params => params['id'])).subscribe((id) => {
      this.status = this.route.snapshot.queryParams.status;
      this.user.currentModule = this.user.switchFeatureSets[id].name;
      this.featureSet = this.user.switchFeatureSets[id];
      this.room = this.user.getRoom(this.featureSet);
      if(this.room){
          this.user.currentModule = this.featureSet.name + " - " + this.room.name; 
      }
      let featuresBuffer = [];

      this.deviceType = this.productService.setDeviceType(this.featureSet.productCode);

      for (let index = 0; index < this.featureSet.features.length; index++) {
        const element = this.user.features[this.featureSet.features[index]];
        if (this.featuresToShow.indexOf(element.attributes.type) >= 0) {
          featuresBuffer.push(element);
        };

        if (element.attributes.type === 'switch' ||
            element.attributes.type === 'movement' ||
            element.attributes.type === 'windowPosition') {
          this.showSwitchGraph(element);
        }
      }
      this.features = featuresBuffer;
    });
    const hasEnergy = (featureId) => {
      const feature = this.user.features[featureId];
      return feature.attributes.type === 'energy';
    };
    this.showLinkBtns = this.featureSet.features.find(hasEnergy)
  }

  async showSwitchGraph(feature) {

    let observable;

    if(this.timespan === 'custom'){
      observable = this.dataAnalytics.getFeatureRawDateRange(feature.featureId, this.timespan, this.startTime, this.endTime);
    }else{
      observable = this.dataAnalytics.getFeatureRawDateRange(feature.featureId, this.timespan);
    }


    observable.subscribe(res => {
      if (this.demo.isDemo() && !res.length) {
        this.switchData = [{
          displayTime: "9 Aug 2022, 11:04:23",
          timestamp: 1660039463022,
          value: 1
        }]
      } else {
        this.switchData = res;
        for(let i = 0; i < this.switchData.length; i++){
          const dt = DateTime.fromMillis(this.switchData[i].timestamp);
          this.switchData[i].displayTime = dt.toLocaleString(DateTime.DATETIME_MED_WITH_SECONDS);
        }
      }
    });
    if(this.timespan === 'custom'){
      this.totalOnData = this.dataAnalytics.getTotalOnTime(feature.featureId, this.timespan, this.startTime, this.endTime);
      return;
    }
    this.totalOnData = this.dataAnalytics.getTotalOnTime(feature.featureId, this.timespan)
  }

  changeRoute() {
    const url = this.rout.url;
    const newUrl = url.replace("switch", "energy");
    this.rout.navigateByUrl(newUrl);
  }

  changeTimeSpan(value) {


    if(value === 'custom'){
      this.dialog.open(TimeSelectComponent).afterClosed().subscribe(result => {
        if(result.timeSelected){
          this.startTime = result.startDate.getTime();
          this.endTime = result.endDate.getTime();
          this.timespan = value;
          this.showGraphs();
        }else{
          return;
        }
      });
      return;
    }

    this.timespan = value;
    this.showGraphs();

  }

  private showGraphs(){
    for (let index = 0; index < this.featureSet.features.length; index++) {
      const element = this.user.features[this.featureSet.features[index]];
      if (element.attributes.type === 'switch' ||
          element.attributes.type === 'movement' ||
          element.attributes.type === 'windowPosition') {
        this.showSwitchGraph(element);
      }
    }
  }

  displayProductCode(productCode) {
    return this.icons.getProductCodeDisplay(productCode);
  }

  onExportClick(){
    this.exportData(this.switchData);
  }

  exportData(data){

    const dialogRef = this.popup.open();

    dialogRef.afterClosed().subscribe(result => {
      this.dataExport.exportData(this.featureSet, data, result);
    });

  }

}
